module.exports = __webpack_public_path__ + "img/paysafecard.4b744b9d.svg";